import * as THREE from 'three'

export type GSplatVector3Input =
  | THREE.Vector3
  | [number, number, number]
  | { x: number; y: number; z: number }
export type GSplatColorInput =
  | THREE.Color
  | [number, number, number]
  | { r: number; g: number; b: number }

export function createVector3(
  value: GSplatVector3Input | undefined,
  fallback: THREE.Vector3
): THREE.Vector3 {
  if (!value) {
    return fallback.clone()
  }
  if (value instanceof THREE.Vector3) {
    return value.clone()
  }
  if (Array.isArray(value)) {
    return new THREE.Vector3(value[0], value[1], value[2])
  }
  return new THREE.Vector3(value.x, value.y, value.z)
}

export function createColor(
  value: GSplatColorInput | undefined,
  fallback: THREE.Color
): THREE.Color {
  if (!value) {
    return fallback.clone()
  }
  if (value instanceof THREE.Color) {
    return value.clone()
  }
  if (Array.isArray(value)) {
    return new THREE.Color(value[0], value[1], value[2])
  }
  return new THREE.Color(value.r, value.g, value.b)
}

export function writeVector3Array(value: THREE.Vector3, target: number[]): number[] {
  target[0] = value.x
  target[1] = value.y
  target[2] = value.z
  return target
}

export function writeColorArray(value: THREE.Color, target: number[]): number[] {
  target[0] = value.r
  target[1] = value.g
  target[2] = value.b
  return target
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value))
}

export function solveWaveTime(distance: number, speed: number, acceleration: number): number {
  if (Math.abs(acceleration) < 1e-6) {
    return speed > 0 ? distance / speed : Infinity
  }

  const discriminant = speed * speed + 2 * acceleration * distance
  if (discriminant < 0) {
    return Infinity
  }
  return (-speed + Math.sqrt(discriminant)) / acceleration
}
